import { useState } from "react";
import { useTranslation } from "react-i18next";
import Dialog from "src/components/Dialog";

export default function SignOutDialog({ close, onSignOut }) {
  const { t } = useTranslation();
  const [isProcessing, setIsProcessing] = useState(false);

  const heading = t("auth.signOutDialog.heading");
  const text = t("auth.signOutDialog.text");
  const buttons = [
    { text: t("buttons.cancel"), onClick: close },
    {
      text: t("buttons.logOut"),
      onClick: () => {
        setIsProcessing(true);
        onSignOut();
      }
    }
  ];
  return (
    <Dialog
      isOpen={true}
      isProcessing={isProcessing}
      heading={heading}
      text={text}
      buttons={buttons}
    />
  );
}
